import { Constants } from "../../Utils/Constants"

export class BackgroundBlockInput extends Phaser.GameObjects.Graphics {
	constructor(scene: Phaser.Scene, private callback?: () => void) {
		super(scene)
		/**
		 * Proper way of event propagation blocking in Phaser
		 * 
		 * https://rexrainbow.github.io/phaser3-rex-notes/docs/site/touchevents/
		 * https://photonstorm.github.io/phaser3-docs/Phaser.Input.Events.html
		 * 
		 * https://photonstorm.github.io/phaser3-docs/Phaser.Input.Events.html#event:GAMEOBJECT_POINTER_MOVE__anchor
		 * 
		 * https://github.com/photonstorm/phaser/blob/0fb0c094c643028cc8a4ee471ecec8919d4937ba/src/input/InputPlugin.js
		 * https://github.com/photonstorm/phaser/blob/0fb0c094c643028cc8a4ee471ecec8919d4937ba/src/input/InputPlugin.js#L230
		 */
		let blockInput = (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
			event.stopPropagation()
			if (this.callback) this.callback()
		}

		this.setInteractive(new Phaser.Geom.Rectangle(0, 0, this.scene.scale.width, this.scene.scale.height), Phaser.Geom.Rectangle.Contains)
		this.on("pointerover", blockInput)
		// Causing big issues on mobile! Reason unknown yet!
		// this.on("pointerout", (pointer: Phaser.Input.Pointer, event: Phaser.Types.Input.EventData) => { event.stopPropagation() })
		this.on("pointerup", blockInput)
		this.on("pointermove", blockInput)
		this.on("pointerdown", blockInput)
		this.setVisible(false)
		// this.scene.children.add(this.background)
	}

	Resize(width: number, height: number): void {
		this.clear()
		this.fillStyle(0x000000, Constants.PANEL.LOCK_SCREEN_OPACITY)
		this.fillRect(0, 0, width, height)

		// * 1000 due to the interactivity not triggering on other half of the mobile device
		// this.background.setInteractive(new Phaser.Geom.Rectangle(0, 0, width*1000, height*1000), Phaser.Geom.Rectangle.Contains)

		// hitArea.setSize() now sets the size properly
		this.input.hitArea.setSize(width * 1000, height * 1000)
		// this.background.input.hitArea.setSize(width,height)
	}
}
